import { Component } from '@angular/core';
import {Router} from "@angular/router";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {

  isGestionReclamo: boolean = false;

  constructor(private router: Router) {
    this.isGestionReclamo = this.router.url.includes('gestion-reclamo-no-voto') || this.router.url.includes('reclamo-enviado-no-voto');
  }

}
